import { useEffect } from "react";

import { TopicContext } from "@state/types";

import { TopicStats } from "./TopicStats.model";

type TopicInput = {
  context: TopicContext;
  id: string;
};

export type SocialUrgencyWebsocketMessage = {
  payload: {
    stats: TopicStats;
    topic: string;
  };
  type: string;
};

type UseSocialUrgencyMessageParams = {
  topicInputs: TopicInput[];
  sendMessage: (message: any) => void;
  lastMessage: SocialUrgencyWebsocketMessage;
  salesChannelCode: string;
};

export type UseSocialUrgencyMessageOutput = {
  id: string | null;
  stats: TopicStats;
};

const constructMessage = (topics: string[]) => ({
  type: "SUB",
  payload: {
    topics,
  },
});

export const useSocialUrgencyMessage = ({
  sendMessage,
  lastMessage,
  topicInputs,
  salesChannelCode,
}: UseSocialUrgencyMessageParams): UseSocialUrgencyMessageOutput => {
  const topics: string = topicInputs.length
    ? topicInputs
        .map((input) => {
          return `${input.context}:${
            input.id
          }:${salesChannelCode.toLowerCase()}:viewers`;
        })
        .join("|")
    : "";

  useEffect(() => {
    if (topics.length > 0) {
      sendMessage(constructMessage(topics.split("|")));
    }
  }, [topics, sendMessage]);

  const { topic } = lastMessage?.payload || {};
  if (topic && topics.indexOf(topic) >= 0) {
    const id = topic.split(":")[1];
    return {
      id,
      stats: lastMessage?.payload?.stats
        ? new TopicStats(lastMessage?.payload?.stats)
        : new TopicStats(),
    };
  }
  return {
    id: null,
    stats: new TopicStats(),
  };
};
